import Cookies from 'js-cookie'
import Vue from 'vue';

import { u_id, user_id } from "@/utils/urlQuery";

const cookieExpires = 1
let vm = new Vue();
export const TOKEN_KEY = 'token';
var u = navigator.userAgent;
var isAd = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

/**
 * 对axios返回的数据进行if判断
 * @param res
 * @param success
 * @param reject
 */

 export const logic = ( res, success, reject ) => {
  if ( res.data.status === 'success' ) {
        /**
         * 请求成功，返回数据
         */
         success && success( res.data.data );
    } else if ( res.data.status === 'fail' ) {
        /**
         * 请求被拒绝，返回错误信息
         */
        vm.$message.warning(res.data.message);
        reject && reject( res.data.errorMsg );
    } else {
        vm.$message.warning(res.data.message);
  }
}

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

// const showThisMenuEle = (item, access) => {
//   if (item.meta && item.meta.access && item.meta.access.length) {
//     if (hasOneOf(item.meta.access, access)) return true
//     else return false
//   } else return true
// }
/*
 * 判断当前字符是否大于0 
 * @method isGoUp
 * @param {string} numStr 要传入的是一个数字字符串
 * @return {boolean} 返回的是当前字符串内的数字是否大于0
*/
export let isGoUp = (numStr) => {
  return +numStr >= 0;
}

/*
 * 截取小数点后两位
 * @method  twoDecimalPlaces
 * @param {string} numStr 要传入的是一个数字字符串

 * @return {boolean} 返回的是当前字符串内的数字是否大于0
*/
export let twoDecimalPlaces = (str) => {
  if (isNaN(str)) {
    return '请传入数字字符串';
  } else {
    if (str.indexOf('.') > 0) {
      return (+str).toFixed(2);
    } else {
      return (+str)
    }
  }
}
/**
 * 判断一个对象是否为空的
 */
export let objectIsEmpty = (obj) => {
  if (typeof obj === "object" && !(obj instanceof Array)) {
    var hasProp = false;
    for (var prop in obj) {
      hasProp = true;
      break;
    }
    if (hasProp) {
      obj = [obj];
      return true
    } else {
      return false;
    }
  }
}

/*
 * 截取小数点后两位
 * @method 
 * @param {string} numStr 要传入的是一个代表秒数的数字字符串  如  ('61')
 * @return {boolean} 返回的是当前字符串转化为时间格式  如 ('01:01')
*/
export let strToTimeStr = (str) => {
  let minuteStr = Math.floor(+str / 60);
  let secondStr = +str % 60;
  minuteStr = minuteStr < 10 ? '0' + minuteStr : minuteStr;
  secondStr = secondStr < 10 ? '0' + secondStr : secondStr;
  return minuteStr + ':' + secondStr;
}
/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}


// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}


export function scrollLoad (callback) {
  return () => {
    // 下拉加载
    const pageHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight
    );
    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      0;
    const scrollHeight =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (pageHeight - viewportHeight - scrollHeight < 20) {
      callback && callback();
    }
  };
}

// 判断滚动距离
export function scrollLoadGoTop(callback) {
  return () => {
    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      0;
    const scrollHeight =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    callback && callback(scrollHeight > viewportHeight?'yes':'no');
      
  }
}

function igpGoToLogin() {}

window.igpGoToLogin = igpGoToLogin;

export function getAppIgpGoToLogin() {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  var data = null;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    if (window.android) {
      console.log("进入安卓登录");
      data = window.android.igpGoToLogin();
    }
  } else if (isiOS) {
    console.log("进入ios登录");
    data = window.igpGoToLogin();
  }
  return data;
}

export function highLight(_str, arr) {
  if (_str !== null) {
    let num_p = -1;
    let rHtml_p = /<a\s+(?:[^>]*?\s+)?class=["']?\b(?:p-a-link)\b["']?(?:[^>]*)>.*?<\/a>/g, //匹配html元素
    aHtml_p = _str.match(rHtml_p); //存放html元素的数组
    _str = _str.replace(rHtml_p, "{-}"); //替换html标签
    let num = -1;
    let rHtml = new RegExp("<.*?>", "ig"), //匹配html元素
    aHtml = _str.match(rHtml); //存放html元素的数组
    _str = _str.replace(rHtml, "{~}"); //替换html标签
    let content_list = [], content_str = {};
    for(let i=0,ilen=arr.length;i<ilen;i++) {
      let item = arr[i].content
      if(item.indexOf("*") == -1) {
        content_list.push(item);
        content_str[item] = arr[i]
      } else if(item.indexOf("*") == 0){
        item = '\\'+item;
        content_list.push(item);
        content_str[item] = arr[i]
      }
    }
    _str = _str.replace(new RegExp(`(${content_list.join('|')})`, 'ig'), match => {
      if(match) {
        const wrapper = document.createElement('a');
        wrapper.className = "p-a-link";
		    let lowStr = match.toLowerCase(), upStr = match.toUpperCase();
        if(content_str[match]) {
          wrapper.setAttribute("data-type", content_str[match].kind);
          wrapper.setAttribute("data-code", content_str[match].code);
          wrapper.setAttribute("data-id", content_str[match].id);
          wrapper.setAttribute("data-name", content_str[match].name);
        } else if(lowStr && content_str[lowStr]){
          wrapper.setAttribute("data-type", content_str[lowStr].kind);
          wrapper.setAttribute("data-code", content_str[lowStr].code);
          wrapper.setAttribute("data-id", content_str[lowStr].id);
          wrapper.setAttribute("data-name", content_str[lowStr].name);
        } else if(upStr && content_str[upStr]) {
          wrapper.setAttribute("data-type", content_str[upStr].kind);
          wrapper.setAttribute("data-code", content_str[upStr].code);
          wrapper.setAttribute("data-id", content_str[upStr].id);
          wrapper.setAttribute("data-name", content_str[upStr].name);
        }
        wrapper.href = 'javascript:;';
        wrapper.target = "_blank";
        wrapper.textContent = match;
        return wrapper.outerHTML;
      } else {
        return match;
      }
    });
    // aHtml_p
    _str = _str.replace(/{-}/g, function() {
      //恢复html标签
      num_p++;
      return aHtml_p[num_p];
    });
    _str = _str.replace(/{~}/g, function() {
      //恢复html标签
      num++;
      return aHtml[num];
    });


    return _str;
  }
}

export function highLightAtUser(_str, arr) {
  if (_str !== null) {
    let num = -1;
    let rHtml = new RegExp("<.*?>", "ig"), //匹配html元素
    aHtml = _str.match(rHtml); //存放html元素的数组
    _str = _str.replace(rHtml, "{~}"); //替换html标签
    let content_list = [], content_str = {};
    for(let i=0,ilen=arr.length;i<ilen;i++) {
      let item = '@' + arr[i].content
      content_list.push(item);
      content_str[item] = arr[i]
    }

    _str = _str.replace(new RegExp(`(${content_list.join('|')})`, 'g'), (match, username) => {
      if(match) {
        const wrapper = document.createElement('a');
        wrapper.className = "p-a-link";

        wrapper.setAttribute("data-type", 'at_user');
        wrapper.setAttribute("data-role", content_str[match].role);
        wrapper.setAttribute("data-id", content_str[match].role != 'user'? content_str[match].l_id: content_str[match].u_id);

        wrapper.href = 'javascript:;';
        wrapper.target = "_blank";
        wrapper.textContent = match;
        return wrapper.outerHTML;
      } else {
        return match;
      }
    });
    _str = _str.replace(/{~}/g, function() {
      //恢复html标签
      num++;
      return aHtml[num];
    });

    return _str;
  }
}

/* 判断是否需要登录 */
export function isLoginInfo() {
	let getUid = decodeURIComponent(u_id), getUserId = decodeURIComponent(user_id);
	
	if(getUid == 0 || getUserId == 0 || !getUserId || !getUid) {
		vm.$srH5CallNativeMethodApp('is_login_page',{})
		return false;
	} else {
		return true
	}
}

/* 重新写入登录数据 */
export function reSetUrl(inObj) {
	let loca = window.location;
	let baseUrl = loca.origin + loca.pathname + "?";
	let query = loca.search.substr(1);
	let obj = {};
	let arr = query.split("&");
	for (let i = 0; i < arr.length; i++) {
		arr[i] = arr[i].split("=");
		obj[arr[i][0]] = arr[i][1];
	}
	if(Object.keys(inObj).length > 0) {
		for(let item in inObj) {
			obj[item] = inObj[item];
		}
	}
	let urls_ =
		baseUrl +
		JSON.stringify(obj)
		  .replace(/[\"\{\}]/g, "")
		  .replace(/\:/g, "=")
		  .replace(/\,/g, "&");
	return urls_;
}



/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
// export const setTitle = (routeItem, vm) => {
//   const handledRoute = getRouteTitleHandled(routeItem)
//   const pageTitle = showTitle(handledRoute, vm)
//   const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
//   window.document.title = resTitle
// }
